export const CONTACT_CAT_ORDER = [
  'מנהלת הדיירים',
  'עורך דין מטעם הדיירים',
  'שמאי מטעם הדיירים',
  'מפקח מטעם הדיירים',
  'יועצת ביטוח מטעם הדיירים',
  'יזם',
  'עורך דין יזם',
  'אדריכל הפרויקט',
  'יועץ מס',
];
